/* RAD LVNG — global navigation feedback (DRAFT). A top progress bar fires on every page
   move (internal link click / form submit) plus a busy state on the clicked button, so the
   slow content_for_header gap never reads as a dead click. Self-contained (injects own CSS).
   AJAX add-to-cart is excluded (rad-xsell.js gives it the spinner -> green "added" feedback). */
(function () {
  if (window.__radNav) return; window.__radNav = true;

  var css = '.rad-progress{position:fixed;top:0;left:0;right:0;height:3px;z-index:100000;opacity:0;pointer-events:none;transition:opacity .25s ease}'
    + '.rad-progress.is-on{opacity:1}.rad-progress.is-done{opacity:0}'
    + '.rad-progress__bar{height:100%;width:0;background:#E0602E;box-shadow:0 0 8px rgba(224,96,46,.5);transition:width .18s ease}'
    + '.rad-busy-x{opacity:.7 !important;cursor:wait !important;pointer-events:none !important}';
  (function () { var s = document.createElement('style'); s.textContent = css; (document.head || document.documentElement).appendChild(s); })();

  var bar, fill, climb, safety;
  function build() { bar = document.createElement('div'); bar.className = 'rad-progress'; fill = document.createElement('div'); fill.className = 'rad-progress__bar'; bar.appendChild(fill); (document.body || document.documentElement).appendChild(bar); }
  function start() {
    if (!bar) build();
    bar.classList.add('is-on'); bar.classList.remove('is-done');
    var p = 6; fill.style.width = p + '%';
    clearInterval(climb);
    climb = setInterval(function () { p += (92 - p) * 0.1; fill.style.width = p.toFixed(1) + '%'; if (p > 91) clearInterval(climb); }, 180);
    clearTimeout(safety); safety = setTimeout(finish, 15000);
  }
  function finish() {
    if (!bar) return;
    clearInterval(climb); clearTimeout(safety);
    fill.style.width = '100%'; bar.classList.add('is-done');
    setTimeout(function () { bar.classList.remove('is-on', 'is-done'); fill.style.width = '0'; }, 350);
  }

  function navigable(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return false;
    if (a.hasAttribute('download')) return false;
    var t = a.getAttribute('target'); if (t && t !== '_self') return false;
    if (a.origin && a.origin !== location.origin) return false;
    if (a.pathname === location.pathname && a.search === location.search) return false; /* same page / hash-only */
    return true;
  }
  function busy(el) {
    if (!el || el.classList.contains('rad-busy-x')) return;
    try { if (el.matches('.button,.btn,button,[class*="btn"],[class*="__cta"],.product-form__submit')) el.classList.add('rad-busy-x'); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && navigable(a)) { busy(e.target.closest('a,button')); start(); }
  }, false);

  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || e.defaultPrevented) return;
    if (f.getAttribute('data-type') === 'add-to-cart-form') return;
    if (f.closest && f.closest('cart-drawer,product-form,quick-add-modal,.xcell__cta')) return;
    start(); var b = f.querySelector('[type="submit"]'); if (b) busy(b);
  }, false);

  window.addEventListener('pagehide', finish);
  window.addEventListener('pageshow', function () { finish(); var els = document.querySelectorAll('.rad-busy-x'); for (var i = 0; i < els.length; i++) els[i].classList.remove('rad-busy-x'); });
})();
